export default __webpack_public_path__ + "static/nolossclub-a29348546b29b001c03812fe86c434da.jpg";